export default {
  init() {
    console.log('xxx');
    $('.about-us__wrapper').on('click', e => {
      console.log();
      $(e.currentTarget).toggleClass('about-us__open');

    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateAboutUs.js